module.exports = {"420526101":"古夫镇","420526102":"昭君镇","420526103":"峡口镇","420526104":"南阳镇","420526105":"黄粮镇","420526106":"水月寺镇","420526201":"高桥乡","420526202":"榛子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420526.json
// module id = 1854
// module chunks = 0